import { useUnblockInvoice } from "@/api/invoice";
import { Button } from "@/components/ui/button";
import { Modal } from "@/components/ui/customs/modal";
import { InvoiceDto } from "@/types/api/api-types";
import { Loader2, LockOpen } from "lucide-react";
import { useTranslation } from "react-i18next";

type ModalProps = {
  closeModal: () => void;
  invoice?: InvoiceDto | null;
};

export const InvoiceUnblockModal = ({ closeModal, invoice }: ModalProps) => {
  const { t } = useTranslation(["boInvoices", "common"]);
  const { mutateAsync: unblockInvoice, isPending } = useUnblockInvoice();

  const handleValidationAction = async () => {
    if (!invoice) {
      return;
    }
    await unblockInvoice(invoice.id);
    closeModal();
  };

  return (
    <Modal
      open={!!invoice}
      onClose={closeModal}
      dismissible
      size="sm"
      title={
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-green-100">
            <LockOpen className="size-5 text-green-600" />
          </div>
          <span>{t("unblockModal.title")}</span>
        </div>
      }
      description={t("unblockModal.description")}
      footer={
        <div className="flex w-full flex-col gap-2 md:flex-row">
          <Button onClick={handleValidationAction} disabled={isPending} className="flex-1">
            {isPending ? <Loader2 className="animate-spin" /> : t("unblockModal.submit")}
          </Button>
          <Button variant="outline" onClick={closeModal} disabled={isPending} className="flex-1">
            {t("common:actions.cancel")}
          </Button>
        </div>
      }
    />
  );
};
